import React from 'react';
import { useTranslation } from 'react-i18next';

import { TTermsAcceptanceChipProps } from '@/backoffice/features/tenants/components/terms-acceptance-chip/terms-acceptance-chip.types';
import { Chip } from '@/shared/components/ui/chip/chip';
import { ChipStatus } from '@/shared/components/ui/chip/chip.types';
import { useDateUtils } from '@/shared/hooks/use-date-utils/use-date-utils';

export const TermsAcceptanceChip: React.FC<TTermsAcceptanceChipProps> = ({
  termsAndConditions,
}) => {
  const { t } = useTranslation();
  const { formatLocalTime } = useDateUtils();

  const accepted = Boolean(termsAndConditions?.accepted);
  const isLatest = Boolean(
    termsAndConditions?.latestTermsAndConditionsVersionAccepted,
  );

  const getChip = (): { status: ChipStatus; tooltip?: string } => {
    if (!accepted) {
      return { status: 'grey' };
    }

    const interpolation = {
      version: termsAndConditions?.termsAndConditionsVersion,
      date: formatLocalTime(termsAndConditions?.acceptedTimestamp),
    };

    if (isLatest) {
      return {
        status: 'green',
        tooltip: t('backoffice:tc_accepted_latest', interpolation),
      };
    }

    return {
      status: 'yellow',
      tooltip: t('backoffice:tc_accepted_previous', interpolation),
    };
  };

  const { status, tooltip } = getChip();
  const label = accepted
    ? t('backoffice:tc_accepted')
    : t('backoffice:tc_not_accepted');

  return (
    <Chip
      status={status}
      label={label}
      tooltip={tooltip}
      tooltipProps={{ noMaxWidth: true }}
    />
  );
};
